import { getUserGuid, getUserVanityId } from '../user';
import useAccessToken from './use-access-token';
/**
 * A hook to get details about the current user.
 *
 * If no user is logged in `null` will be returned.
 */

var useCurrentUser = function useCurrentUser() {
  var accessToken = useAccessToken();

  if (!accessToken) {
    return null;
  }

  return {
    guid: getUserGuid(accessToken),
    vanityId: getUserVanityId(accessToken)
  };
};

export default useCurrentUser;